<template>
  <div class="ag-custom-header-renderer">
    <div class="ag-custom-header-renderer-text">
      <MdTypography :data-qa-id="fieldName + '-header'" tag="h1" color="spirits--700" variant="body2--medium">
        {{ headerText }}
      </MdTypography>
      <MdIconEditableField v-if="showIcon" :data-qa-id="fieldName + '-header'" color="spirits--700" />
    </div>
    <div v-if="sortEnabled" class="cursor--pointer" @click="handleSort">
      <MdIconSortInactive
        v-if="currentSort === AG_GRID_HEADER_RENDERER.sortNone"
        :data-qa-id="fieldName + '-sort-icon'"
        color="spirits--700"
      />
      <MdIconSortAsc
        v-else-if="currentSort === SORTING_ORDER_DIRECTION.asc"
        :data-qa-id="fieldName + '-sort-icon'"
        color="spirits--700"
      />
      <MdIconSort
        v-else-if="currentSort === SORTING_ORDER_DIRECTION.desc"
        :data-qa-id="fieldName + '-sort-icon'"
        color="spirits--700"
      />
    </div>
  </div>
</template>

<script setup>
import {
  MdTypography,
  MdIconEditableField,
  MdIconSortInactive,
  MdIconSort,
  MdIconSortAsc
} from '@antiqua-dls/vue-components';
import { AG_GRID_HEADER_RENDERER, SORTING_ORDER_DIRECTION } from 'src/utils/constants/common';

// Define the component name
defineOptions({
  name: 'HeaderRenderer'
});

// define the props
const props = defineProps({
  params: {
    type: Object,
    default: () => ({})
  }
});

const { fieldName, headerText, showIcon, sortEnabled = false, currentSort = null, onSortChange = null } = props.params;

const handleSort = () => {
  if (onSortChange) {
    let newSortDirection;
    if (currentSort === SORTING_ORDER_DIRECTION.asc) {
      newSortDirection = SORTING_ORDER_DIRECTION.desc;
    } else if (currentSort === SORTING_ORDER_DIRECTION.desc) {
      newSortDirection = AG_GRID_HEADER_RENDERER.sortNone;
    } else {
      newSortDirection = SORTING_ORDER_DIRECTION.asc;
    }
    onSortChange(newSortDirection);
  }
};
</script>

<!-- Scoped CSS does npt work in AgGrid renderer components, so we use global styles -->
<style>
.ag-custom-header-renderer {
  display: flex;
  align-items: center;
  gap: var(--md-spacing-unit--sm);
  width: 100%;
}

.ag-custom-header-renderer-text {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--md-spacing-unit--xs);
  flex: 1 0 0;
}
</style>
